<template>
  <fade-left
    :show="showState"
    @hideModel="hideModelFn"
  >
    <div class=comModals>
      <div class=modal-body>
        <div class='header'>
          <div class=search>
            <input
              type="text"
              placeholder="搜索网吧名/计算机名"
              v-model="keyword"
              @keyup.enter="searchKeyword()"
              @blur="searchKeyword()"
            >
            <a
              href="#"
              @click.prevent="searchKeyword()"
            ><img
                src="@/assets/img/icon/u502.png"
                alt=""
              ></a>
          </div>
        </div>
        <div class="table-content">
          <table-list
            ref=serverLabel
            @pagechange="getServerLists"
            @labelColumn='labelColumn'
            :total="parseInt(total)"
            :page="parseInt(page)"
            :loading="tableLoading"
            :table-list="tableData.list"
          ></table-list>
        </div>
      </div>
      <div class=bottom>
        <div class=right>
          <a
            href=#
            class=blue-btn
            @click.stop.prevent="confirm"
          >应用</a>
          <a
            href=#
            class=default-btn
            @click.stop.prevent="cancle"
          >取消</a>
        </div>
      </div>
    </div>
  </fade-left>
</template>
<script>
import FadeLeft from "_c/modals/fadeLeft";
import TableList from './TableList'
import { getServerLists, setServerLabel } from '@/requests/bar'
export default {
  name: 'Modal',
  components: {
    TableList,
    FadeLeft
  },
  data() {
    return {
      showState: false,
      labelId: "",
      keyword: "",
      total: 0,
      page: 1,
      tableData: {
        list: []
      },
      tableLoading: false,
      successFn: ''
    }
  },
  mounted() {
    window.$modal.serverApplication = {}
    window.$modal.serverApplication.show = (labelId) => {
      this.labelId = labelId;
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true)
        })
      })
    }
  },
  methods: {
    hideModelFn(val) {
      this.showState = val
    },
    // 初始化信息
    init(fn) {
      this.keyword = ''
      this.getServerLists(1, '', '')
      this.showState = true;
      this.successFn = fn
    },
    // 分页获取服务器列表
    async getServerLists(pageNum, orderColumn, orderType) {
      this.tableData.list = []
      this.tableLoading = true
      let res = await getServerLists({
        page: pageNum,
        pageSize: 20,
        search: this.keyword,
        orderColumn: orderColumn,
        orderType: orderType
      })
      this.tableData.list = res.records
      this.total = parseInt(res.total)
      this.page = parseInt(res.current)
      this.tableLoading = false
    },
    labelColumn(val, col) {
      this.getServerLists(this.page, val, col)
    },
    searchKeyword() {
      this.getServerLists(this.page, '', '')
    },
    async confirm() {
      if (this.$refs.serverLabel.allCheck) {
        let res = await setServerLabel({
          serverList: [],
          labelId: this.labelId,
          search: this.keyword
        })
        if (res.code === 200) {
          // this.$refs.serverLabelallCheck = false;
          this.getServerLists(1, '', '')
          this.showState = false;
          this.successFn()
        } else {
          window.$Message.show({
            title: '服务器标签管理',
            type: 'error',
            msg: res.msg
          })
        }
      } else {
        let res = await setServerLabel({
          serverList: this.$refs.serverLabel.selectedBarIds(),
          labelId: this.labelId,
          search: this.keyword
        })
        if (res.code === 200) {
          this.getServerLists(1, '', '')
          this.showState = false;
          this.successFn()
        } else {
          window.$Message.show({
            title: '服务器标签管理',
            type: 'error',
            msg: res.msg
          })
        }
      }
    },
    cancle() {
      this.showState = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
.comModals {
  color: $black-1;
  width: 740px;
}
.modal-body {
  padding: 10px;
  padding-left: 30px;
  padding-right: 30px;
  text-align: left;
  .header {
    background: #fff;
    padding: 5px;
    border: 1px solid rgba(230, 230, 230, 1);
    .search {
      display: inline-block;
      input {
        width: 280px;
        height: 30px;
        border: 1px solid rgba(230, 230, 230, 1);
        font-size: 12px;
        color: #a1a1a1;
        padding-left: 10px;
      }
      a {
        display: inline-block;
        width: 61px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: rgba(242, 242, 242, 1);
        border: 1px solid rgba(230, 230, 230, 1);
        border-left: none;
      }
    }
  }
}
.bottom {
  overflow: hidden;
  text-align: right;
  padding-right: 30px;
  padding-left: 30px;
  height: 70px;
  a {
    min-width: 60px;
    text-align: center;
    margin-left: 10px;
  }
  .right {
    padding: 20px 0;
    float: right;
  }
}
</style>